import { combineReducers } from 'redux';

import appConfig from './AppConfigReducer';
import appOptions from './AppOptionsReducer';
import appSettings from './AppSettingsReducer';
import attachments from './AttachmentsReducer';
import auth from './AuthReducer';
import bulkImport from './BulkImportReducer';
import certification from './CertificationReducer';
import configureDatasources from './ConfigureDatasourcesReducer';
import customerLogo from './CustomerLogoReducer';
import dashboardConfig from './DashboardConfigReducer';
import dashboard from './DashboardReducer';
import dataLookupValues from './DataValueLookupReducer';
import dialogStates from './DialogStatesReducer';
import documentCollaboration from './DocumentCollaborationReducer';
import documentRepository from './DocumentRepositoryReducer';
import documentViewer from './DocumentViewerReducer';
import enhancedModal from './EnhancedModalReducer';
import entityDisplayPage from './EntityDisplayReducer';
import entityHistory from './EntityHistoryReducer';
import errors from './ErrorReducer';
import favorites from './FavoritesReducer';
import formHistory from './FormHistoryReducer';
import helpTopics from './HelpTopicsReducer';
import linkPreviewResults from './LinkPreviewResultsReducer';
import masterSetupPage from './MasterSetupPageReducer';
import navigation from './NavigationReducer';
import networkStatus from './NetworkStatusReducer';
import notifications from './NotificationsReducer';
import offlineData from './OfflineDataReducer';
import orgHierarchy from './OrgHierarchyReducer';
import panelLayout from './PanelLayoutReducer';
import powerBI from './PowerBIReducer';
import productHierarchy from './ProductHierarchyReducer';
import recentEvents from './RecentEventsReducer';
import regulatoryDictionaries from './RegulatoryTermsReducer';
import repositoryConfiguration from './RepositoryConfigurationReduce';
import savedSearchColumns from './SavedSearchColumnsReducer';
import savedSearches from './SavedSearchesReducer';
import savedSearchExport from './SavedSearchExportReducer';
import savedSearchFilters from './SavedSearchFiltersReducer';
import savedSearchResults from './SavedSearchResultsReducer';
import searchPage from './SearchPageReducer';
import searchTreeViewData from './SearchTreeViewDataReducer';
import sidenav from './SidenavReducer';
import successes from './SuccessReducer';
import taskCountByStatus from './TaskCountByStatusReducer';
import taskStatusPanel from './TaskStatusPanelReducer';
import toasts from './ToastReducer';
import topMenu from './TopMenuReducer';
import translatedColumnLists from './TranslatedColumnListsReducer';
import translations from './TranslationReducer';
import upgradeModules from './UpgradeModulesReducer';
import userRights from './UserRightsReducer';
import userRoles from './UserRolesReducer';
import warnings from './WarningReducer';
import workflow from './WorkflowReducer';
import { CLEAR_STORE } from '../actions/AppAction';
import appMigration from '../app-migration/reducers/app-migration.reducer';
import entityEditor from '../entity-designer/reducers/entity-designer.reducer';
import formDesigner from '../form-designer/reducers/form-manager.reducer';
import longLoadPageMessage from '../reducers/LongLoadPageInfoReducer';
import reportDesigner from '../report-designer/reducers/report-designer.reducer';
import reportModelDesigner from '../report-model-designer/reducers/report-model-designer.reducer';
import savedSearchDesigner from '../saved-search-designer/reducers/saved-search-designer.reducer';

export default function rootReducer(state, action) {
  const appReducer = combineReducers({
    appConfig,
    appMigration,
    appOptions,
    appSettings,
    customerLogo,
    toasts,
    attachments,
    auth,
    formDesigner,
    workflow,
    taskStatusPanel,
    taskCountByStatus,
    dashboard,
    dashboardConfig,
    navigation,
    sidenav,
    successes,
    errors,
    warnings,
    translations,
    panelLayout,
    savedSearches,
    savedSearchResults,
    savedSearchColumns,
    savedSearchFilters,
    savedSearchExport,
    masterSetupPage,
    entityDisplayPage,
    orgHierarchy,
    productHierarchy,
    searchPage,
    topMenu,
    searchTreeViewData,
    recentEvents,
    favorites,
    dataLookupValues,
    documentViewer,
    documentCollaboration,
    documentRepository,
    userRoles,
    userRights,
    certification,
    regulatoryDictionaries,
    upgradeModules,
    helpTopics,
    formHistory,
    enhancedModal,
    notifications,
    bulkImport,
    entityEditor,
    savedSearchDesigner,
    entityHistory,
    networkStatus,
    offlineData,
    dialogStates,
    translatedColumnLists,
    powerBI,
    reportModelDesigner,
    longLoadPageMessage,
    reportDesigner,
    linkPreviewResults,
    configureDatasources,
    repositoryConfiguration,
  });

  const _state =
    action.type === CLEAR_STORE
      ? {
          errors: state.errors,
          successes: state.successes,
          savedSearchFilters: state.savedSearchFilters,
          savedSearchResults: state.savedSearchResults,
        }
      : state;

  return appReducer(_state, action);
}
